export function safeAsign(value: any) {
  if (value == "" || value == undefined || value == null) return true;
  else return false;
}
